import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-generator-dialog',
    templateUrl: './generator-dialog.component.html',
    styleUrls: ['./generator-dialog.component.scss'],
    standalone: false
})
export class GeneratorDialogComponent implements OnInit {

  public input;

  constructor(
    public dialogRef: MatDialogRef<GeneratorDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
  }

  ngOnInit() {
  }

}
